var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"crumb",style:({ width: _vm.w })},[_vm._v(" "+_vm._s(_vm.text)),_c('span',{staticClass:"crumb-item"},[_vm._v(_vm._s(_vm.active))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }